module.exports = __webpack_public_path__ + "img/14.952abc7b.png";